import {useTranslation} from 'react-i18next'
import {Tag} from '@/components/ui/tag'
import {AmberDot} from '@/components/amber-dot'
import {HelpIcon} from '@/components/help-icon'
import {chipDeEstado} from '@/lib/cola-estados'
import type {TarjetaCola} from '@/lib/bateria-cola'

/** El chip verde solo aparece cuando decidió una persona. ≤ 3 palabras (U21): el nombre va al `title` y a `sr-only`. */
export function ChipDeEstado({tarjeta}: {tarjeta: TarjetaCola}) {
  const {t} = useTranslation()
  const chip = chipDeEstado(tarjeta)
  const claveCorta = chip.nombre ? `${chip.clave}SinNombre` : chip.clave
  const etiqueta = t(`admin.bateria.cola.estado.${claveCorta}`)
  const conNombre = chip.nombre ? t(`admin.bateria.cola.estado.${chip.clave}`, {nombre: chip.nombre}) : null
  return (
    <span className="inline-flex items-center gap-1" data-estado={tarjeta.estado}>
      <Tag tone={chip.tono} data-testid="cola-chip-estado" title={conNombre ?? undefined}>
        {chip.puntoDelSistema && (
          <AmberDot label={t('common.senal.propuestaDelSistema')} className="mr-1 h-1.5 w-1.5" />
        )}
        {etiqueta}
        {conNombre && <span className="sr-only"> — {conNombre}</span>}
      </Tag>
      {/* Sin el porqué, una tarjeta sin respuesta posible se ve idéntica a una rota. */}
      {chip.clave === 'noAplica' && (
        <HelpIcon
          label={t('common.help.iconLabelFor', {campo: t('admin.bateria.cola.estado.noAplica')})}
          testId="cola-no-aplica-ayuda">
          {t('admin.bateria.cola.estado.noAplicaAyuda')}
        </HelpIcon>
      )}
    </span>
  )
}
